import styles from "./ImageLayoutCarouselCenter.module.css";

import ImageCarousel from "./ImageCarousel";
import ImageSlot from "./ImageSlot";

interface Props {
    editing?: boolean;
    images: { [key: string | number]: File | string | null };
    onImageChange?: (key: string | number, newImage: File | null) => void;
}

export default function ImageLayoutCarouselCenter({
    editing,
    images,
    onImageChange,
}: Props) {
    return (
        <div className={styles.imageContainer}>
            <ImageSlot
                label="Cover Image"
                image={images.cover}
                width={340}
                height={570}
                onImageChange={(img) => {
                    if (onImageChange) onImageChange("cover", img);
                }}
                editing={editing}
            />

            <ImageCarousel
                images={images}
                editing={editing}
                width={690}
                height={570}
                size={editing ? 3 : undefined}
                onImageChange={(index, file) => {
                    if (onImageChange) onImageChange(index, file);
                }}
            />

            <ImageSlot
                label="Hover Image"
                image={images.hover}
                width={340}
                height={570}
                onImageChange={(img) => {
                    if (onImageChange) onImageChange("hover", img);
                }}
                editing={editing}
            />
        </div>
    );
}
